import React, { useEffect } from "react";
import welmart from "../../assets/dashboard/navCard/walmart.svg";
import apple from "../../assets/dashboard/navCard/apple.svg";
import amazone from "../../assets/dashboard/navCard/amzone.svg";
import visa from "../../assets/dashboard/navCard/visa.svg";
import hotel from "../../assets/dashboard/navCard/hotel.svg";
import lowes from "../../assets/dashboard/navCard/lowes.svg";
import tjmax from "../../assets/dashboard/navCard/tjmax.svg";
import dickes from "../../assets/dashboard/navCard/dickes.svg";
import { useAuth } from "context/auth-context";
import { useQuery } from "@tanstack/react-query";
import { getCompleteCount, getEnableUserForRedeemApi, JoinNowBonusBalanceApi } from "./Dasboard.api";
import { useWalletDetails } from "hooks/useWalletDetails";
import { useBonusPoints } from "hooks/useBonusPointsDetails";
import { bonusDetailsType } from "types/useCustomHookTypes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiGift } from "react-icons/fi";

function NavCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [enabled, setEnabled] = React.useState<boolean>(false);
  const svgs = [welmart, apple, amazone, visa, hotel, lowes, tjmax, dickes];
  const { auth } = useAuth();
  const [completeCount, setCompleteCount] = React.useState<number>(0);

  const getJoinNowBonusBalance = useQuery(
    ["getBonusPoint", auth.panelistId],
    () => JoinNowBonusBalanceApi(auth.panelistId),
    {
      refetchOnWindowFocus: false,
    }
  );

  const enabledUser = useQuery(
    ["getenabledUser"],
    () => getEnableUserForRedeemApi(),
    {
      refetchOnWindowFocus: false,
    }
  );

  const completeCountData = useQuery(
    ["completeCount", auth.panelistId],
    () => getCompleteCount(auth.panelistId),
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (completeCountData && completeCountData?.data) {
      setCompleteCount(completeCountData.data.result);
    }
  }, [completeCountData]);

  // ✅ check if current user is in enabled user list
  const isUserEnabledForRedeem = React.useMemo(() => {
    const panelListString = enabledUser?.data?.result?.[0][0]?.panelListId || "";
    const isActive = enabledUser?.data?.result?.[0][0]?.isActive || "";
    if (isActive === 1) {
      const enabledIds = panelListString
        .split(",")
        .map((id: string) => id.trim());

      return enabledIds.includes(String(auth.panelistId));
    } else if (isActive === 2) {
      return true;
    } else {
      return false;
    }
  }, [enabledUser, auth.panelistId]);

  const walletDetails: Record<string, number | undefined> = useWalletDetails();
  const bonusDetails: bonusDetailsType | null = useBonusPoints();

  useEffect(() => {
    if (walletDetails && bonusDetails) {
      setEnabled(walletDetails?.userWalletPoints >= Number(bonusDetails?.data?.target_points));
    }
  }, [walletDetails, bonusDetails]);
  return (
    <section className="flex flex-col w-full h-full gap-4 p-4 overflow-hidden zs-card sm:p-5 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-start min-w-0 gap-3 sm:gap-4">
        <span
          className={`inline-flex items-center justify-center w-10 h-10 rounded-lg shrink-0 ${
            bonusDetails?.data?.isActive ? "bg-primary-soft text-primary-text" : "bg-warning-soft text-warning"
          }`}
        >
          <FiGift className="w-5 h-5" />
        </span>
        <div className="min-w-0">
          {bonusDetails?.data?.isActive ? (
            <p className="text-sm leading-relaxed text-ink-2">
              {t("referfriend.deaultmessage.youmay")}{" "}
              <span className="font-semibold text-ink">{t("referfriend.deaultmessage.redeemrewards")} </span>
              {t("referfriend.deaultmessage.afterreaching")}
              <span className="font-semibold text-ink">
                &nbsp;{+getJoinNowBonusBalance?.data?.claimPoint} {t("referfriend.deaultmessage.afterpoint")}&nbsp;
              </span>
              {t("referfriend.deaultmessage.afterpoint2")}
            </p>
          ) : (
            <div className="text-sm">
              {bonusDetails?.data?.target_points != null && bonusDetails?.data?.points != null ? (
                <p className="text-ink-2">
                  <span className="font-semibold text-warning">Keep going!</span> Just{" "}
                  <span className="font-semibold tabular-nums text-ink">
                    {Number(bonusDetails.data.target_points) - Number(bonusDetails.data.points)}
                  </span>{" "}
                  more points until you can claim your reward.
                </p>
              ) : (
                <p className="text-ink-3">Loading reward progress...</p>
              )}
            </div>
          )}
          <div className="flex flex-wrap items-center gap-1.5 mt-3" aria-label="Reward partners">
            {svgs.map((svg, index) => (
              <span
                key={index}
                className="h-7 px-1.5 zs-logo-plate"
              >
                <img src={svg} alt={`svg-${index}`} className="w-auto h-5" />
              </span>
            ))}
          </div>
        </div>
      </div>
      {isUserEnabledForRedeem && (
        <div className="shrink-0">
          <button
            disabled={!enabled}
            onClick={() => {
              if (!enabled) return;
              if (completeCount < 2) {
                alert("Complete at least 2 surveys to redeem rewards.");
                return;
              }
              navigate("/redeem/form/bonus", {
                state: { redeem_point: walletDetails?.userWalletPoints, email: auth.email },
              });
            }}
            className="w-full zs-btn zs-btn-primary lg:w-auto"
          >
            {t("page.referral.rewads")}
            <FiArrowRight />
          </button>
        </div>
      )}
    </section>
  );

}

export default NavCard;